import { MenuItem } from '@mui/material';
import * as XLSX from 'xlsx';
import * as React from 'react';
import {
    gridFilteredSortedRowIdsSelector,
    gridVisibleColumnFieldsSelector,
    useGridApiContext,
    gridVisibleColumnDefinitionsSelector,
} from '@mui/x-data-grid-pro';

function getExcelData(apiRef) {
    // Select rows and columns
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

    // Format the data. Here we only keep the value
    const data = filteredSortedRowIds.map((id) => {
        const row = {};
        visibleColumnsField.forEach((field) => {
            let _field = field
            if(Number(field)){
                _field = "_"+field
            }
            row[_field] = apiRef.current.getCellParams(id, field).value;
        });
        return row;
    });

    return data;
}

// const getFilteredRows = ({ apiRef }) => gridExpandedSortedRowIdsSelector(apiRef);
function handleExport(apiRef, options) {
    const file_name = options.fileName
    const data = getExcelData(apiRef);
    const keys = gridVisibleColumnFieldsSelector(apiRef);
    const columns = gridVisibleColumnDefinitionsSelector(apiRef)
    let columnNames = []
    let columnGroup = []
    
    const allGroup = apiRef.current.unstable_getAllGroupDetails()
    columns.forEach((column) => {
        if(Object.keys(allGroup).length > 0) {
            if(apiRef.current.unstable_getColumnGroupPath(column.field).length > 0){
                columnGroup.push(allGroup[apiRef.current.unstable_getColumnGroupPath(column.field)[0]].headerName)
            }
            else columnGroup.push("")
        }
        columnNames.push(column.headerName)
    })

    console.log(columnNames);
    
    const rows = data.map((row) => {
        const mRow = {};
        for (const key of keys) {
            let _key = key
            if(Number(key)){
                _key = "_"+ key
            }
            mRow[_key] = row[_key];
        }
        return mRow;
    });

    console.log(rows);

    const worksheet = columnGroup.length > 0 ? XLSX.utils.json_to_sheet(rows, {origin: 'A3', skipHeader: true }): XLSX.utils.json_to_sheet(rows);

    console.log(worksheet);
    if(columnGroup.length > 0){
        XLSX.utils.sheet_add_aoa(worksheet, [[...columnGroup], [...columnNames]], {
            origin: 'A1',
        });
    }
    else{
        XLSX.utils.sheet_add_aoa(worksheet, [[...columnNames]], {
            origin: 'A1',
        });
    }
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, file_name);
    XLSX.writeFile(workbook, `${file_name}_${new Date().getTime()}.xlsx`, { compression: true });
}



export function ExportMenuItem(props){
    const { hideMenu, options } = props;
    const apiRef = useGridApiContext();
    
    return (
        <MenuItem
            onClick={() => {
                handleExport(apiRef, options);
                hideMenu?.()
            }}
        >
            Download as Excel
        </MenuItem>
    );
}
